import ExpandPanel from '@monofront/design-system/components/ExpandPanel';
import { daysOfWeek } from '@monofront/business/constants';

type SelectionBlockProps = {
  onSelect: () => void;
  buttonLabel: string;
  expandLabel: string;
  openingHours: {
    day: number;
    hours: string[];
  }[];
};

export const PickupPointSelectionBlock: React.FC<SelectionBlockProps> = ({
  onSelect,
  buttonLabel,
  expandLabel,
  openingHours,
}) => {
  const hasOpeningHours =
    openingHours
      .map(({ hours }) => {
        return hours;
      })
      .flat().length > 0;

  return (
    <ExpandPanel.Details isInline>
      <ExpandPanel.Summary>
        <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
          <div className="tw-flex tw-flex-1 tw-items-center tw-gap-2">
            {hasOpeningHours && (
              <>
                <span className="tw-lf-body-bold-md">{expandLabel}</span>
                <ExpandPanel.ExpandIcon />
              </>
            )}
          </div>

          <button
            onClick={onSelect}
            className="tw-lf-button tw-lf-button-primary tw-lf-button-md"
          >
            {buttonLabel}
          </button>
        </div>
      </ExpandPanel.Summary>
      {hasOpeningHours && (
        <table className="tw-mt-2 tw-w-full tw-border-spacing-0">
          <tbody>
            {openingHours.map(({ day, hours }) => (
              <tr key={day}>
                <td className="tw-lf-body-regular-md tw-py-1">
                  {daysOfWeek[day]}
                </td>
                {hours.map((hour) => (
                  <td
                    className="tw-lf-body-bold-md tw-py-1 tw-text-right"
                    key={hour}
                  >
                    {hour}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </ExpandPanel.Details>
  );
};
